import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageConstants } from '../common/LocalStorageConstants';
import { LoginService } from '../_services/login/login.service';
import { CustomLoaderCComponent } from '../CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [CustomLoaderCComponent]
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    submitted = false;
    returnUrl: string;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private spinner: CustomLoaderCComponent,
        private toastrService: ToastrService,
        public authService: LoginService) { }

    ngOnInit() {
        localStorage.clear();
        sessionStorage.clear();
        
        document.title = "Login"
        this.loginForm = this.formBuilder.group({
            UserName: ['', Validators.required],
            Password: ['', Validators.required]
        });

        if (localStorage.getItem(LocalStorageConstants.CURRENT_USER)) {
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    tryLogin() {

        // stop here if form is invalid
        if (this.loginForm.invalid) {

            return;
        }
        this.submitted = true;
        const value = {
            UserName: this.f.UserName.value,
            Password: this.f.Password.value
        };
        this.spinner.showSpinner();

        if (!this.loginForm.invalid) {
            this.authService.Login(value)
                .subscribe(
                    (res: any) => {
                        if (res.result == 1) {
                            if (res.token != null && res.token != undefined) {
                                this.setUserInStorage(res);
                                let returnUrl = '/dashboard/newdashboard';
                                if (this.returnUrl) {
                                    returnUrl = this.returnUrl;
                                }
                                this.spinner.hideSpinner();
                                this.router.navigate([returnUrl]);
                            }
                        }
                        else {
                            this.spinner.hideSpinner();
                            this.submitted = false;
                            this.toastrService.error(res.userMessage, '', { timeOut: 4000, closeButton: true });
                        }
                        this.submitted = false;
                    },
                    error => {
                        this.submitted = false;
                        this.spinner.hideSpinner();
                    }
                )
        }
    }

    setUserInStorage(res) {
        localStorage.setItem(LocalStorageConstants.CURRENT_USER, JSON.stringify(res));
        localStorage.setItem(LocalStorageConstants.TOKEN, res.token);
        localStorage.setItem(LocalStorageConstants.MASTER_DATA, JSON.stringify(res.lstMasterDatas));
        localStorage.setItem(LocalStorageConstants.USER_TYPE_DESCRIPTION, res.role);
        localStorage.setItem(LocalStorageConstants.CLIENT_ID, res.idClient);
    }
}
